import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pageAction } from '../redux_files/actions/page_actions';

const Aboutus = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'About Us';
    dispatch(pageAction('About Us'));
  });
  return (
    <>
      <div className='container'>
        <div className='aboutus outer-border pd-20'>
          Our mission is to provide homemade food to people staying away from home and are compelled to eat Masale wala food. We will
          provide simple food to all at very low cost.
          <br />
          <br />
          This idea came to our mind when we visited some other city once for some work, there we struggled a lot to get simple homemade
          food and even after trying different restaurants we were unable to get simple food. Everyhere there were too much of spices and oil.
          <br />
          <br />
          Its been more than a year we have been serving you people, and thank your for all your support and love.
        </div>
      </div>
    </>
  );
};

export default Aboutus;
